export function resolveShellConfig(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var featureGates = _a.featureGates, featureSettings = _a.featureSettings, identity = _a.identity, componentContext = _a.componentContext;
    var isMsa = identity.isMsa;
    var appSwitchUrl = componentContext.appSwitchUrl, appSwitchToUrl = componentContext.appSwitchToUrl, cdnDomain = componentContext.cdnDomain, logoutUrl = componentContext.logoutUrl, officeStartManifestVersion = componentContext.officeStartManifestVersion, testTraffic = componentContext.testTraffic, isBootstrappedFromReactHarmony = componentContext.isBootstrappedFromReactHarmony;
    // Feature Gates
    var consumerShellServiceEnabled = (_c = (_b = featureGates.shellGates) === null || _b === void 0 ? void 0 : _b.shellConsumerShellServiceEnabled) !== null && _c !== void 0 ? _c : false;
    var darkModeEnabled = (_e = (_d = featureGates.authModelGates) === null || _d === void 0 ? void 0 : _d.authModelDarkModeEnabled) !== null && _e !== void 0 ? _e : false;
    // FeatureSettings
    var aadAppId = (_g = (_f = featureSettings.authOptions) === null || _f === void 0 ? void 0 : _f.aadAppId) !== null && _g !== void 0 ? _g : '';
    var bootstrapperHost = (_j = (_h = featureSettings.shell) === null || _h === void 0 ? void 0 : _h.bootstrapperHost) !== null && _j !== void 0 ? _j : '';
    var rootUrl = "https://".concat(location.host, "/");
    // If v2/React, use dynamic TPN url generated from rolling build.
    // If other Hybrid, use server side generated config or fallback to default Angular Harmony TPN url.
    var thirdPartyNoticeUrl = isBootstrappedFromReactHarmony
        ? "https://".concat(cdnDomain, "/officestarthtml/OSPO/NOTICE-").concat(officeStartManifestVersion, ".html")
        : (_k = componentContext.thirdPartyNoticeUrl) !== null && _k !== void 0 ? _k : 'https://res.cdn.office.net/officehub/versionless/officehome/thirdpartynotice.html';
    var acctSwitchingConfig = {
        type: 'webAadWithMsaProxy',
        login_Hint: identity.loginHint,
        appSignInUrl: rootUrl,
        appSignInToUrl: rootUrl,
        appSignOutUrl: '',
        appSwitchUrl: appSwitchUrl !== null && appSwitchUrl !== void 0 ? appSwitchUrl : '',
        appSwitchToUrl: appSwitchToUrl !== null && appSwitchToUrl !== void 0 ? appSwitchToUrl : '',
        aad: {
            wreply: rootUrl,
            appId: aadAppId,
        },
        msa: {
            wreply: rootUrl,
            siteId: aadAppId,
        },
    };
    return {
        acctSwitchingConfig: acctSwitchingConfig,
        activityTimeout: (_l = identity.activityTimeout) !== null && _l !== void 0 ? _l : 0,
        consumerShellServiceEnabled: isMsa && consumerShellServiceEnabled,
        controlsClaim: (_m = identity.controlsClaim) !== null && _m !== void 0 ? _m : [],
        culture: componentContext.preferredCulture,
        darkModeEnabled: darkModeEnabled,
        isConsumer: isMsa,
        languageCode: '',
        logoutUrl: logoutUrl !== null && logoutUrl !== void 0 ? logoutUrl : '',
        puid: identity.puid,
        shellBootHost: bootstrapperHost,
        signinState: (_o = identity.signInState) !== null && _o !== void 0 ? _o : [],
        testTraffic: testTraffic,
        thirdPartyNoticeUrl: thirdPartyNoticeUrl,
        upn: (_p = identity.userPrincipalName) !== null && _p !== void 0 ? _p : '',
        userDisplayName: (_q = identity.userDisplayName) !== null && _q !== void 0 ? _q : '',
    };
}
//# sourceMappingURL=resolveShellConfig.js.map